<script setup lang="ts">

</script>

<template>
  <div class="layout">
    <header class="layout-top">
      <default-layout-header :is-auth-mode="true"/>
    </header>
    <main class="layout-main">
      <slot/>
    </main>
    <footer class="layout-footer">
      <default-layout-footer/>
    </footer>
    <snackbar/>
  </div>
</template>

<style scoped lang="scss">
@use "assets/css/tokens/colors.scss" as *;
@use "assets/css/tokens/typography" as *;

.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
}

.layout-top {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background-color: var(--layout-bg, $color-white);
  border-bottom: 1px solid $color-border;
  padding: 1rem 5vw;
}

.layout-footer {
  display: flex;
  justify-content: center;
  padding: clamp(1.5rem, 3vw, 2.5rem) 5vw;
}

.layout-main {
  flex: 1;
  display: flex;
  padding-top: calc(1rem * 2 + max(clamp(30px, 4vw, 48px), 2.5rem));

  @media (max-width: 959px) {
    padding-top: calc(1rem * 2 + max(clamp(30px, 4vw, 48px), 2rem));
  }
}

</style>